export default __webpack_public_path__ + "static/media/sketch16.9b7704e4.png";